import React from 'react';
import './LexiBridgeLoader.css';

/**
 * LexiBridgeLoader — Branded inline loading component
 * Shows the Lexi|Bridge wordmark with animated divider bar,
 * shimmer effect, scanning progress track, and floating particles.
 *
 * Props:
 *   message  — optional status text shown beneath the wordmark
 *   compact  — if true, hides the status text and particles for tighter layouts
 */
const LexiBridgeLoader = ({ message, compact = false }) => {
  return (
    <div className="lb-loader">
      {/* Micro-particles */}
      {!compact && (
        <div className="lb-loader-particles">
          <div className="lb-loader-dot" />
          <div className="lb-loader-dot" />
          <div className="lb-loader-dot" />
          <div className="lb-loader-dot" />
          <div className="lb-loader-dot" />
          <div className="lb-loader-dot" />
        </div>
      )}

      {/* Wordmark with divider bar */}
      <div className="lb-loader-wm">
        <span className="lb-loader-char lx">L</span>
        <span className="lb-loader-char lx">e</span>
        <span className="lb-loader-char lx">x</span>
        <span className="lb-loader-char lx">i</span>
        <div className="lb-loader-bar" />
        <span className="lb-loader-char br">B</span>
        <span className="lb-loader-char br">r</span>
        <span className="lb-loader-char br">i</span>
        <span className="lb-loader-char br">d</span>
        <span className="lb-loader-char br">g</span>
        <span className="lb-loader-char br">e</span>
      </div>

      {/* Progress track */}
      <div className="lb-loader-track">
        <div className="lb-loader-fill" />
      </div>

      {/* Optional status text */}
      {!compact && <span className="lb-loader-text">{message || 'Loading'}</span>}
    </div>
  );
};

export default LexiBridgeLoader;
